<template>
  <el-dialog
    :title="title"
    :visible.sync="isShow"
    @close="handleClose"
    width="560px"
    class="rc-dialog"
  >
    <el-form
      size="small"
      ref="Form"
      :model="item"
      :rules="rules"
      class="form"
      label-width="100px"
    >
      <el-form-item label="栏目名称：" prop="subjectName">
        <el-input
          v-model="item.subjectName"
          size="small"
          placeholder="请输入期刊栏目"
          clearable
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click="handleClose" title="取消"></butn>
      <butn btntype="primary" @click="submitForm" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import Bus from "../Bus";
import rulesFactory from "@/utils/rules";
import {
  subjectInfo,
  subjectSave,
  subjectUpdate
} from "@/api/periodicalSubject";

export default {
  name: "curd",

  components: { butn },
  data() {
    return {
      isShow: false,
      title: "",
      item: {},
      rules: {
        subjectName: [rulesFactory.required("请输入栏目名称")]
      }
    };
  },
  methods: {
    handleClose() {
      this.$refs["Form"].resetFields();
      this.item = {};
      this.isShow = false;
    },
    showFrom(msg) {
      this.isShow = true;
      this.title = msg;
    },
    info(uuid) {
      subjectInfo(uuid).then(res => {
        if (res && res.code == 0) {
          this.item = res.data;
        }
      });
    },
    submitForm() {
      this.$refs["Form"].validate(valid => {
        if (valid) {
          if (!this.item.uuid) {
            // 新增
            subjectSave(this.item).then(res => {
              if (!res || res.code != 0) return;
              Bus.$emit("reload");
              this.handleClose();
            });
          } else {
            //编辑
            subjectUpdate(this.item).then(res => {
              if (!res || res.code != 0) return;
              this.$message.success(res.msg);
              Bus.$emit("reload");
              this.handleClose();
            });
          }
        }
      });
    }
  },
  created() {
    Bus.$on("addSubject", periodicalId => {
      this.item.periodicalId = periodicalId;
      this.showFrom("新增");
    });
    Bus.$on("updateSubject", item => {
      this.info(item.uuid);
      this.showFrom("编辑");
    });
  }
};
</script>

<style lang="scss" scoped>
.rc-dialog .form /deep/ .el-form-item {
  margin-bottom: 0;
  .el-input {
    width: 80%;
  }
}
</style>
